module.exports = __webpack_public_path__ + "img/w_wait.077c7a85.png";